var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#396A28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1661 7.43175L9 6.26625L7.82606 7.43962L6.60881 6.22238L9 2.8125L11.4075 6.19031L10.1661 7.43175ZM7.41937 7.84687L6.26625 9L7.43175 10.1661L6.219 11.3788L2.8125 9L6.18187 6.60938L7.41937 7.84687ZM10.5604 10.1739L11.7338 9L10.5727 7.839L11.8249 6.58687L15.1875 9L11.7877 11.4013L10.5604 10.1739ZM7.839 10.5733L9 11.7338L10.1531 10.5806L11.3805 11.8086L9 15.1875L6.63525 11.7765L7.839 10.5733ZM9 7.04644L10.953 9L9 10.953L7.047 9L9 7.04644Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElla);
export default __webpack_public_path__ + "static/media/ella.86535256def743be103075cba701310e.svg";
export { ForwardRef as ReactComponent };